import { useState, useEffect, useCallback } from 'react'
import { jsPDF } from 'jspdf'
import Cookies from 'js-cookie'
import Loader from 'components/ui/loader/Loader'
import { getCertificateData } from 'api/certificates/Get'
import { ICourseCertificateUser } from 'models/certificate.model'
import GeneratePdf from 'components/reusables/generatePdf'
import { MobileEvents } from 'enum/mobileEvents.enum'
import styles from './Generate.module.scss'

interface GenerateProps {
  certificateId: string
  courseId: number | string
}

const Generate = ({ certificateId, courseId }: GenerateProps) => {
  const [certificate, setCertificate] = useState<ICourseCertificateUser | null>(
    null
  )

  const getCertificate = useCallback(async () => {
    const data = await getCertificateData({
      certificateId,
      courseId: courseId.toString() === '0' ? null : courseId,
    })
    setCertificate(data.data.data.attributes)
  }, [certificateId, courseId])

  useEffect(() => {
    getCertificate()
  }, [getCertificate])

  const sendEventToMobileWebView = useCallback(
    (eventType: string, data: any) => {
      if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: eventType,
            data,
          })
        )
      }
    },
    []
  )

  const onGenerate = (pdf: jsPDF | null) => {
    const isAppMobile = Cookies.getJSON('rankmi_flavour_mobile')
    if (!pdf) {
      // GeneratePdf ya notifica el error; no cerrar la ventana
      return
    }

    const fileName = `${certificate?.user.fullName} (${certificate?.user.identifier}).pdf`

    if (isAppMobile) {
      const arrayBuffer = pdf.output('arraybuffer')
      sendEventToMobileWebView(MobileEvents.CERTIFICATE_DOWNLOAD_PDF, {
        buffer: Array.from(new Uint8Array(arrayBuffer)),
        fileName: fileName,
        mimeType: 'application/pdf',
        isGoBack: true,
      })
    } else {
      pdf.save(fileName, { returnPromise: true })
      setTimeout(() => window.close(), 1000)
    }
  }

  return (
    <div>
      <Loader overlay color className={styles.overlay} />
      {certificate && (
        <GeneratePdf
          content={certificate.template.html}
          backgroundImage={certificate.template.bgImage}
          onGenerate={onGenerate}
        />
      )}
    </div>
  )
}

export default Generate
